/** Shared helpers for sample and substrate filter stores. */

export function valueDiffers(a: unknown, b: unknown): boolean {
  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) return true;
    return a.some((v, i) => v !== b[i]);
  }
  if (a instanceof Date && b instanceof Date) return a.getTime() !== b.getTime();
  if (a instanceof Date || b instanceof Date) return (a == null) !== (b == null);
  if (typeof b === 'boolean') {
    const aFalsy = a === undefined || a === null || a === false;
    if (b === false) return !aFalsy;
    return a !== true;
  }
  return a !== b;
}
